module.exports = __webpack_public_path__ + "img/IconPlansBranco.227a3c1c.png";